import React, { useContext } from 'react';
import { Toaster } from 'react-hot-toast';
import { ToasterContextProps, ToasterOptions } from '../types/ToastProps';
import { useToastNotification } from '../utils/hooks/useToastNotification';

export const useToasterContext = () => useContext(ToasterContext);

export const ToasterContext = React.createContext<ToasterContextProps>({
  showToast: () => {
    // we shouldn't return an empty function here should we?
  },
});

export const ToastProvider = ({
  position = 'top-right',
  reverseOrder = false,
  gutter = 5,
  children,
}: React.PropsWithChildren<ToasterOptions>) => {
  const showToast = useToastNotification();
  return (
    <ToasterContext.Provider value={{ showToast }}>
      <Toaster
        position={position}
        reverseOrder={reverseOrder}
        gutter={gutter}
        containerStyle={{
          top: 20,
          left: 20,
          bottom: 20,
          right: 20,
        }}
      />
      {children}
    </ToasterContext.Provider>
  );
};
